import React from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import {
  PropertyImageOverlay,
  PropertyThumbnail,
  PIFBody,
} from "../../components";

import axios from "../../api/axios";

const PIFView = () => {
  const state = useSelector((state) => state.UserReducer);
  const { propertyInformationId } = useParams();
  const propertyInformationUrl = "/pif/" + propertyInformationId;
  const navigate = useNavigate();

  const [propertyImageAttachments, setPropertyImageAttachments] =
    React.useState([]);
  const [propertyInformationData, setPropertyInformationtData] = React.useState(
    {},
  );
  const [propertySubType, setPropertySubType] = React.useState("Building"); // Building / Land
  const [markerCoordinates, setMarkerCoordinates] = React.useState({
    lat: 0,
    lng: 0,
  });

  const getServiceTicketDetails = (serviceTicketId) => {
    try {
      axios
        .get("/serviceticket/" + serviceTicketId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.serviceTicket) {
            setPropertySubType(
              response.data.serviceTicket.subPropertyOptionId.name,
            );
          } else {
            toast.error(response.data.message);
            navigate(-1);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const getPropertyInformationDetails = () => {
    try {
      axios
        .get(propertyInformationUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.propertyInformation) {
            setPropertyInformationtData(response.data.propertyInformation);
            // console.log(response.data.propertyInformation.serviceTicketId);
            setPageTitle(
              "Service #" +
                response.data.propertyInformation.serviceTicketId
                  ?.serviceTicketID +
                " - PIF - L&L ERP",
            );
            getServiceTicketDetails(
              response.data.propertyInformation.serviceTicketId._id,
            );
            setThumbnailImage(response.data.propertyInformation.thumbnail);
            const markerCoord = {
              lat: response.data.propertyInformation.latitude,
              lng: response.data.propertyInformation.longitude,
            };
            setMarkerCoordinates(markerCoord);
            setPropertyImageAttachments(
              response.data.propertyInformation.propertyImages,
            );
          } else {
            toast.error(response.data.message);
            navigate(-1);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [focusedImage, setFocusedImage] = React.useState(null);
  const closeConfirmation = () => {
    setFocusedImage(null);
  };

  const [thumbnailImage, setThumbnailImage] = React.useState({ blobName: "" });

  const [pageTitle, setPageTitle] = React.useState("Service - PIF - L&L ERP");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getPropertyInformationDetails();
  }, []);

  return (
    <>
      {focusedImage && (
        <PropertyImageOverlay
          item={focusedImage}
          closeConfirmation={closeConfirmation}
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 px-0'>
            <div className='px-2 py-0 sm:px-0'>
              <div className='block'>
                <div className='shadow overflow-hidden sm:rounded-md'>
                  <div className='px-2 py-5 bg-gray-50 sm:p-6'>
                    <div className='lg:items-center justify-between'>
                      <div className='flex gap-3 min-w-0 px-0 lg:px-0'>
                        <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                          Property Information
                        </h2>
                        {propertyInformationData._id ? (
                          <Link
                            to={
                              "/serviceticket/" +
                              propertyInformationData?.serviceTicketId?._id
                            }
                            className='ml-0 mt-0 justify-center py-1 px-2.5 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none '>
                            Service #
                            {
                              propertyInformationData?.serviceTicketId
                                ?.serviceTicketID
                            }
                          </Link>
                        ) : (
                          <span className='mt-0 block py-0 sm:text-sm'>
                            <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                              <div className='w-24 bg-gray-100 h-4 rounded-md '></div>
                            </div>
                          </span>
                        )}
                      </div>
                    </div>
                    {propertyInformationData?._id && (
                      <PIFBody
                        propertyInformationData={propertyInformationData}
                        markerCoordinates={markerCoordinates}
                        propertySubType={propertySubType}
                      />
                    )}
                    <div className='mt-2 grid grid-cols-12 gap-2 bg-gray-100 rounded-md p-4'>
                      <div className='col-span-12 min-w-0 px-0 lg:px-0 mb-2'>
                        <h2 className='text-lg font-semibold leading-3 text-gray-dark '>
                          Gallery
                        </h2>
                      </div>
                      {/* <div className='col-span-12 sm:col-span-2'>
                        <label
                          htmlFor=''
                          className='block text-sm font-medium text-gray-700'>
                          Thumbnail
                        </label>
                        <div className='flex p-2 justify-center '>
                         
                          <PropertyThumbnail
                            thumbnail={thumbnailImage}
                            isthumbnail={true}
                          />
                        </div>
                      </div> */}

                      <div className='col-span-12 sm:col-span-12'>
                        <label
                          htmlFor=''
                          className='block text-sm font-medium text-gray-700'>
                          Property Images
                        </label>
                        <div className='grid grid-cols-8 gap-2'>
                          {propertyImageAttachments.length !== 0 ? (
                            propertyImageAttachments.map((item) => (
                              <div
                                className='col-span-4 sm:col-span-1 flex justify-center cursor-pointer'
                                key={item.blobName}
                                onClick={(event) => {
                                  setFocusedImage(item);
                                }}>
                                <PropertyThumbnail thumbnail={item} />
                              </div>
                            ))
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                    <div className='lg:flex lg:items-center justify-between'>
                      <div className={`flex-1 min-w-0 px-0 lg:px-0 `}>
                        <Link
                          to='#'
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(-1);
                          }}
                          className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-xs font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                          Back
                        </Link>
                        {(state.user._id ===
                          propertyInformationData?.createdBy?._id ||
                          state.user.aclGroup === "admin" ||
                          state.user.aclGroup === "super-admin") && (
                          <Link
                            to={
                              "/serviceticket/pif/edit/" +
                              propertyInformationData?.serviceTicketId?._id
                            }
                            className='ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-xs font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                            Edit PIF
                          </Link>
                        )}
                      </div>
                    </div>
                    <div className='sm: py-2'></div>
                  </div>
                </div>
              </div>
              <div className='block md:hidden'>
                <div className='grid grid-cols-1 gap-4'></div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default PIFView;
